import { render } from "./AppInterestRadio.vue?vue&type=template&id=76a6549b"
import script from "./AppInterestRadio.vue?vue&type=script&lang=ts"
export * from "./AppInterestRadio.vue?vue&type=script&lang=ts"
script.render = render

export default script